function directive() {
  return {
    restrict: 'A',
    link(scope, element, attributes) {
      scope.$watch(attributes.ngIndeterminate, (value) => {
        element.prop('indeterminate', !!value);
      });
    }
  };
}

export default function (ngModule) {
  ngModule.directive('ngIndeterminate', directive);
}
